/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Copy_Event_TextInputs */



/**
* | output |
* | --- |
* | "Copy Event Text" |
*
* @param {Event_Group_Options_Copy_Event_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_copy_event_text = /** @type {((inputs?: Event_Group_Options_Copy_Event_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Copy_Event_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier le texte de l'événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignistext kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia testo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Копировать текст события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar texto del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制事件文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントテキストをコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट टेक्स्ट कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar texto do evento")
	return /** @type {LocalizedString} */ ("Copy Event Text")
});